import type { CSSProperties } from 'react';
import type { BlockStyle } from '@/blocks/domain/types';
import { blockFontFamilyCss, blockFontSizeCss, blockFontWeightCss } from '@/document-render/application/blockFontSize';
import { ACCENT_COLORS, BORDER_COLORS, TEXT_COLORS } from '@/common/presentation/constants/colors';
import { MONEY_CELL_STYLE } from '@/document-render/presentation/blocks/moneyCellStyles';

export const PRICE_BOOK_EMPTY_TEXT = 'Rate schedule — no entries yet.';

export const HIDDEN_OPACITY = 0.5;

export function priceBookSectionStyle(style: BlockStyle): CSSProperties {
  return {
    paddingTop: style.paddingY,
    paddingBottom: style.paddingY,
    color: style.textColor,
    background: style.backgroundColor,
    fontSize: blockFontSizeCss(style),
    fontWeight: blockFontWeightCss(style),
    fontFamily: blockFontFamilyCss(style)
  };
}

export const TITLE_STYLE: CSSProperties = { fontWeight: 700, marginBottom: 6 };
export const EMPTY_STYLE: CSSProperties = { fontSize: 12, fontStyle: 'italic', color: TEXT_COLORS.MUTED };
export const SHEET_HEADING_STYLE: CSSProperties = { fontWeight: 700, marginTop: 8 };
export const SHEET_NOTE_STYLE: CSSProperties = { fontSize: 11, color: TEXT_COLORS.MUTED, marginBottom: 4 };
export const SUBSECTION_LABEL_STYLE: CSSProperties = {
  fontSize: 10,
  fontWeight: 700,
  letterSpacing: '.08em',
  textTransform: 'uppercase',
  color: TEXT_COLORS.MUTED,
  marginTop: 6
};
export const RATE_TABLE_STYLE: CSSProperties = { width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' };

export function rateHeadCellStyle(align: 'left' | 'right', fontSize: number | string = 10): CSSProperties {
  return {
    padding: '6px 10px',
    fontSize,
    fontWeight: 700,
    color: TEXT_COLORS.ON_FAINT,
    background: BORDER_COLORS.FAINT,
    textAlign: align,
    ...(align === 'right' ? MONEY_CELL_STYLE : {})
  };
}

export function rateBodyCellStyle(align: 'left' | 'right', emphasis: boolean): CSSProperties {
  return {
    padding: '6px 10px',
    borderBottom: `1px solid ${BORDER_COLORS.LIGHT}`,
    textAlign: align,
    fontWeight: emphasis ? 700 : undefined,
    overflowWrap: 'break-word',
    ...(align === 'right' ? MONEY_CELL_STYLE : {})
  };
}

export function selectionOutline(selected: boolean): CSSProperties {
  return selected ? { outline: `2px solid ${ACCENT_COLORS.DEFAULT}`, outlineOffset: 2 } : {};
}

export const VISUALLY_HIDDEN_STYLE: CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap'
};
